import { produce } from 'immer';
import type { BuildInfo } from 'app/globalTypes';
import { WEBSOCKET_STATUS } from './types';

export type WebsocketStatusSlice = {
    isConnected: boolean;
    nextRetry: number | null;
    maintenanceStarted: boolean | null;
    suspended: boolean | null;
    services: Record<string, string> | null;
    buildInfo: BuildInfo | null;
};

export const INITIAL_STATE: WebsocketStatusSlice = {
    isConnected: true,
    maintenanceStarted: null,
    suspended: null,
    nextRetry: null,
    services: null,
    buildInfo: null
};

export const websocketStatusReducer = produce((draft, action) => {
    switch (action.type) {
        case WEBSOCKET_STATUS:
            draft.isConnected = action.payload.status.isConnected;
            draft.nextRetry = action.payload.status.nextRetry;
            draft.maintenanceStarted = action.payload.status.systemStatus?.maintenanceStarted;

            // [TODO] remove the nullish coalesce once heartbeat returns the actual status
            draft.suspended = action.payload.status.systemStatus?.suspended ?? false;
            draft.services = action.payload.status.systemStatus?.services;
            draft.buildInfo = action.payload.status.systemStatus?.buildInfo;

            if (!window.europa) {
                window.europa = {};
            }

            window.europa.systemStatus = action.payload.status.systemStatus;
            break;
        default:
            break;
    }
}, INITIAL_STATE);
